import { render, staticRenderFns } from "./CsrProcessIndex.vue?vue&type=template&id=12ad1cd0&scoped=true&"
import script from "./CsrProcessIndex.vue?vue&type=script&lang=js&"
export * from "./CsrProcessIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ad1cd0",
  null
  
)

export default component.exports